export default __webpack_public_path__ + "static/media/icon.6539e174.png";